import { render, staticRenderFns } from "./correlationRatio.vue?vue&type=template&id=b79b0f80&scoped=true"
import script from "./correlationRatio.vue?vue&type=script&lang=js"
export * from "./correlationRatio.vue?vue&type=script&lang=js"
import style0 from "./correlationRatio.vue?vue&type=style&index=0&id=b79b0f80&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79b0f80",
  null
  
)

export default component.exports